<template>
    <card class="image-cover-card border-primary clickable" :class="topContent ? 'content-top' : ''" :style="`background-image:url('${image}'); min-height: 350px;`" :to="`/book-a-property?markets%5B0%5D=${market.id}`">
        <div :class="topContent ? null : 'mt-auto'">
            <card-body>
                <h4>
                    Explore<br />
                    <em>{{ market.name }}</em>
                </h4>

            </card-body>
        </div>
    </card>
</template>

<script type="text/javascript">
    import CommonComponents from '@/components/Common.vue';
    import ApiObject from '@/classes/ApiObject.js';

    export default {
        components: {
            ...CommonComponents,
        },

        props: {
            market: {
                type: ApiObject,
                required: true,
            },

            topContent: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            image() {
                if (
                    (this.market) &&
                    (this.market.displayImageSrc)
                ) {
                    return this.market.displayImageSrc;
                }
                return 'https://d1c0fl3x3xd6n4.cloudfront.net/market-regions/XRNEnt1i6372725046d69.jpeg';
            },
        },
    };

</script>
